import { messages } from '../WidgetMessage'

const Error = () => (
  <div className="flex justify-center items-center h-36 bg-coolGray-50 border-coolGray-100 border-t">
    <p className="text-red-400 max-w-125">{messages.error}</p>
  </div>
)

export default Error
